module.exports = __webpack_public_path__ + "img/1F924.e124b210.svg";